import {AuthI18n} from '@/locales/base.message.locales';

export const auth: AuthI18n = {
  titles: {
    login: 'Log in',
    join_the_league: 'Join the league',
    login_with_facebook: 'Facebook',
    login_with_google: 'Google',
    create_account: 'Create your account to start',
    or_sign_in_with: 'OR LOGIN WITH',
    forget_password_question: 'Did you forgot your password?',
    forget_password: 'No problem, we going to fix this',
    change_password: 'Now we going o change your password',
    welcome: 'Welcome to the league',
    account_has_validated: 'Account successfully validated!',
    account_has_not_validated: 'We were unable to verify your account, please try again!',
    account_already_validated: 'your account has already been verified',
    validation_account: 'Validating your account...',
    request_confirmation_email: 'Resend account validation email',
    accept_terms_of_use: ' Terms and Conditions',
    accept_t: 'Accept',
    accept_p: 'Accept',
    accept_privacy_policy: ' Privacy Policy',
    almost_there: 'We are almost there!',
    complete_registration: 'To complete your registration on the platform, declare below that you accept the terms of use as well as the privacy policies.'
  },
  subtitle: {
    forget_password: 'Please, provide your email',
    change_password: 'Please, provide a new password and confirm it',
    sent_confirmation_email: 'We sent a confirmation link to your email.',
  },
  buttons: {
    complete_profile: 'Complete my profile',
    join_the_league: 'Join the League',
    lost_password: 'Lost your password ?',
    new_user: 'New User',
    remember_be: 'Remember me',
    recover_password: 'Recover my password',
    change_password: 'Change Password',
    create_account: 'Create Account',
    create: 'Create',
  },
  message: {
    forgot_email_not_found: 'Sorry, we dont found your email address',
    forgot_email_send: 'We sent you an email with a recovery link',
    token_expiration: 'I\'m sorry, but it looks like your link is expired or invalid, please request a new link',
    password_has_changed: 'Password has updated with success',
    credentials_has_updated: 'Credentials has updated with success',
    credentials_not_updated: 'Ops.. fail to update your credentials, please try again later',

  },

};
